import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { BottomNavigation, BottomNavigationAction, Container, Grid, ImageList, ImageListItem, Link, SpeedDial, SpeedDialAction, Typography, useMediaQuery } from '@mui/material';
import Paper from '@mui/material/Paper';
import './Landing.css';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import HomeIcon from '@mui/icons-material/Home';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useParams } from 'react-router-dom';
import Header from './header';
import { WifiCalling3 } from '@mui/icons-material';
import { fetchProperties, formatNumber, getPhotoUrl, PropertyData } from './properties';


export default function Property() {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [properties, setProperties] = useState<PropertyData[]>([]);
    let theme = createTheme();
    

    let  matchDownMd = useMediaQuery(theme.breakpoints.down('md'));



    const { id } = useParams()

    
    theme = responsiveFontSizes(theme);

    const propiedad = properties.find(item => item.id === id);

    const actions = [
        { icon: <Link sx={{ color: 'inherit'  }} href="tel:+56963928601"><WifiCalling3  sx={{ color: 'inherit' , maxWidth: { xs: 50, md: 170 } }}/></Link>, name: 'Llámame' },

        { icon: <Link sx={{ color: 'inherit'}} href={"https://wa.me/+56963928601/?text=Hola quiero consultar por la propiedad : " + propiedad?.titulo}><WhatsAppIcon  style={{ color: 'green' }} /> </Link>, name: 'Envíame un Whatsapp' },
    ];
    

    useEffect(() => {

        window.scrollTo(0, 0)

    }, [])

    useEffect(() => {
        fetchProperties()
            .then(setProperties)
            .catch((err) => setError(err instanceof Error ? err.message : 'No se pudo cargar la propiedad'))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (<Typography sx={{ p: 4 }}>Cargando propiedad...</Typography>)
    }

    if (error) {
        return (<Typography sx={{ p: 4 }}>{error}</Typography>)
    }

    if (propiedad === undefined) {
        return (<Typography sx={{ p: 4 }}>Propiedad no encontrada.</Typography>)
    }
    else {
        return (
            <div>
                <ThemeProvider theme={theme}>
                    <SpeedDial
                        ariaLabel="SpeedDial basic example"
                        sx={{ position: 'fixed', bottom: 10, right: 10, '& .MuiFab-primary': { width: 110, height: 110 } 
                        
                    
                    }}
                        
                        icon={
                            <Box sx={{ display: "flex" }}>
                                <Typography> Agenda Tu Visita </Typography>
                            </Box>
                        }
                    >
                        {actions.map((action) => (
                            <SpeedDialAction
                                sx={{width: 70, height: 70 }}
                                key={action.name}
                                icon={action.icon}
                                tooltipTitle={action.name}
                            />
                        ))}
                    </SpeedDial>
                </ThemeProvider>

                <Header></Header>
                <Container>
                    <Grid container spacing={5} sx={{ pt: 20, pl: 2, pr: 2 }} >
                        <Grid item xs={12}></Grid>
                        <Grid item xs={12} >
                            <Typography variant="h6" gutterBottom> {formatNumber(propiedad.precio)} UF - {propiedad.titulo}  </Typography>


                            <Grid container spacing={0} sx={{ pt: 0, pl: 0, pr: 0 }} >
                            <Typography variant="body2" gutterBottom>{propiedad.descripcion}
                            <br></br>
<b>Comuna</b>: {propiedad.comuna}  
<b> Piso</b>: {propiedad.piso}  
<b> Tipo</b>: {propiedad.tipo}    
<b> Orientación</b> : {propiedad.orientacion}  
<b> M2 Útiles</b>: {propiedad.m2}  
<b> Año</b>: {propiedad.year}  
<b> M2 Terraza</b>: {propiedad.terraza}   
<b> Gastos Comunes</b>: {formatNumber(propiedad.GComunes)}  
<b> M2 Totales</b>: {propiedad.m2_totales}  
<b> Contribuciones</b>: {formatNumber(propiedad.Contribuciones)}  
<b> Dormitorios</b>: {propiedad.dormitorios}  
<b> Otros</b>: {propiedad.otros}  
<b> Baños</b>: {propiedad.banhos}  
<b> Calefacción</b>: {propiedad.calefaccion}  
<b> Estacionamientos</b>: {propiedad.estacionamientos}  
<b> Agua Caliente</b>: {propiedad.aguacaliente}  
<b> Bodega</b>: {propiedad.bodega}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} >
                            <ImageList sx={{
                                mb: 8,
                                
                              
                            }} 
                            cols={matchDownMd ? 1 : 2}
                             >
                                {propiedad.fotos.map((item) => (
                                    <ImageListItem key={item.img}>
                                        <img
                                            
                                            srcSet={getPhotoUrl(item)}
                                            src={getPhotoUrl(item)}
                                            alt={propiedad.titulo}
                                            loading="lazy"
                                        />
                                    </ImageListItem>
                                ))}
                            </ImageList>
                        </Grid>
                    </Grid>
                    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
                        <BottomNavigation showLabels   >

                            <BottomNavigationAction label="Home" icon={<Link sx={{ color: 'inherit' }} href={`${process.env.PUBLIC_URL}`}>  <HomeIcon /></Link>} />
                        </BottomNavigation>
                    </Paper>
                </Container>

            </div>
        )
    }
}

